import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { publicRoutes, dashboardRoutes } from './routes';
import { useSelector } from 'react-redux';
import { useEffect } from 'react'; 
import { PARTNER_BRANDS, isValidPartnerSlug } from './partner';

// ✅ Separate component to safely use useLocation inside Router

const PartnerSlugTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const segment = location.pathname.split("/")[1] || "";
    const firstSegment = decodeURIComponent(segment).toLowerCase();

    if (isValidPartnerSlug(firstSegment)) {
      sessionStorage.setItem("partnerSlug", firstSegment);
    }
    // 🚫 No else/removeItem here — non-partner routes should NOT clear it
  }, [location.pathname]);

  return null;
};

const App = () => {
  const isAuthenticated = useSelector((state) => state.auth.accessToken);

  // ✅ Read partnerSlug for unauthenticated redirect
  const partnerSlug = sessionStorage.getItem('partnerSlug');
  const loginRedirectPath = partnerSlug ? `/${partnerSlug}` : '/login';

  return (
    <Router>
      {/* ✅ Tracks partner slug safely inside Router context */}
      <PartnerSlugTracker />

      <Routes>
        {publicRoutes.map(({ path, exact, component: Component }) => (
          <Route
            key={path}
            path={path}
            exact={exact}
            element={<Component />}
          />
        ))}
        {dashboardRoutes.map(({ path, exact, component: Component }) => (
          <Route
            key={path}
            path={path}
            exact={exact}
            element={
              isAuthenticated ? <Component /> : (
                // ✅ Redirects to /login/vivo instead of /login
                <Navigate to={loginRedirectPath} replace />
              )
            }
          />
        ))}
        <Route
          path="*"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              // ✅ Redirects to /login/vivo instead of /login
              <Navigate to={loginRedirectPath} replace />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default App;